import React, { useState, useEffect, useRef } from "react";
import gearIcon from "./img/gear.png";

import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import { Form } from "react-bootstrap";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import { de } from "date-fns/locale/de";
import { useConfig } from "./ConfigContext";
registerLocale("de", de);

export default function ProjektstatusOptionenSidebar({ topic, stufenOptionen, setStufenOptionen }) {
   const config = useConfig();
   return (
      <div className="sidebar-optionen">
         {config.projektstatusBereiche.map((bereich) => (
            <ProjektstatusOptionButton
               stufenOptionen={stufenOptionen}
               setStufenOptionen={setStufenOptionen}
               topic={bereich}
            />
         ))}
         {/* 

         <ProjektstatusOptionButton
            stufenOptionen={stufenOptionen}
            setStufenOptionen={setStufenOptionen}
            topic={"Expo-Kontrolle"}
         />

         <ProjektstatusOptionButton
            stufenOptionen={stufenOptionen}
            setStufenOptionen={setStufenOptionen}
            topic={"Notartermine"}
         />
         <ProjektstatusOptionButton
            stufenOptionen={stufenOptionen}
            setStufenOptionen={setStufenOptionen}
            topic={"Auswertung"}
         /> */}
      </div>
   );
}

function ProjektstatusOptionButton({ stufenOptionen, setStufenOptionen, topic }) {
   return (
      <button
         className="sidebar-button"
         onClick={() => {
            let newOptions = structuredClone(stufenOptionen);
            if (newOptions[topic]) {
               delete newOptions[topic];
            } else {
               newOptions[topic] = true;
            }
            setStufenOptionen(newOptions);
            console.log(newOptions);

            localStorage.setItem("pStatOpt", JSON.stringify(newOptions));
         }}
         style={
            stufenOptionen[topic]
               ? {
                    backgroundColor: "#224",
                    color: "#fff",
                 }
               : { backgroundColor: "#fff", color: "#224", borderColor: "#ddd" }
         }
      >
         {topic}
      </button>
   );
}
